import { h } from 'preact';
import * as Styled from './styles';

export default function VideoChapters({ videoChapters, currentTime, handleClick, accessibilityOptions }) {
    if (!videoChapters || !videoChapters.links.length) return '';

    return (
        <Styled.VideoChapters darkModeOn={accessibilityOptions?.darkMode}>
            <Styled.VideoChaptersTitle>{ videoChapters.title }</Styled.VideoChaptersTitle>

            <Styled.ChaptersWrapper>
                {videoChapters.links.map((chapter, index) => {
                    const time = Number(chapter.promoUrl);

                    // convert time to M:SS
                    let secs = Math.floor(time % 60);
                    let mins = Math.floor(time / 60 % 60);

                    // Check if leading zero is need for seconds
                    secs = (secs < 10) ? '0' + secs : secs;

                    return (
                        <Styled.VideoChaptersBtn
                            key={chapter.linkText + index}
                            isActive={currentTime >= time}
                            chaptersLength={videoChapters.links.length}
                            darkModeOn={accessibilityOptions?.darkMode}
                            onClick={() => handleClick(time)}
                        >
                            <Styled.ChapterTime> { `${mins}:${secs} `} </Styled.ChapterTime>
                            <Styled.ChapterTitle> {chapter.linkText} </Styled.ChapterTitle>
                        </Styled.VideoChaptersBtn>
                    );
                })}
            </Styled.ChaptersWrapper>
        </Styled.VideoChapters>
    )
};